import request from '@/utils/request'

export function confirmRequest(id) {
  const method = 'put'
  const url = '/request/confirm/' + id
  return request({
    url,
    method
  })
}

// la lista delle request e' una custom API perche'
// mi serve anche la lista delle drugs
export function getRequestList (entity, filters, pagination) {
  const method = 'get'
  const url = '/request/list'

  // custom multifilter
  if (filters['response_has_drug.drug_id']) {
    const drug_id = filters['response_has_drug.drug_id']
    filters['drug_id'] = [ {'response_has_drug.drug_id': drug_id}, {'request_has_drug.drug_id': drug_id }]
    delete filters['response_has_drug.drug_id']
  }

  return request({
    headers: {
      'x-filters': JSON.stringify(filters),
      'x-pagination': JSON.stringify(pagination)
    },
    url, method
  })
}

export function updateRequestHasDrug(item) {
  const method = 'put'
  const url = `/request_has_drug/${item.request_id}_${item.drug_id}`
  return request({
    url,
    method,
    data: item
  })
}
